import Cancelimg from "../../assets/img/cancel-01.svg";
import useTranslator from "../../hooks/useTranslator";

const DeleteConfiration = ({
  isOpen,
  onClose,
  name,
  relation,
  heading,
  description,
  btn1Text,
  btn2Text,
  btn1Functionality,
  btn2Functionality,
  submitLoading = false,
}) => {
  const { _t } = useTranslator();
  if (!isOpen) return;

  return (
    <div className="approvedModal popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen">
      <div className="popup-content2 popup-content bg-white guarantorDocuments">
        <div className="row">
          <div className="col-12 d-flex gap-4 align-items-center justify-content-between heading-section">
            <div>
              <h4>{heading}</h4>
            </div>
            <div>
              <img
                src={Cancelimg}
                alt="icon"
                className="canceicon"
                onClick={onClose}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-4">
              <div className="annual-report annualReport d-flex align-items-center gap-2">
                <img
                  className="docoment-img2 guaranterImg"
                  src="/images/guarantor-icon.svg"
                  alt="icon"
                />
                <div>
                  <p className="staticdata_div userNameHere custom-gap-2 align-items-center">
                    {name}
                    <span className="">{relation}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <p className="tenant-doc-text">{description}</p>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-2">
          <button
            type="button"
            className="btnNext btnnextpre w-100"
            onClick={btn1Functionality}
          >
            {btn1Text}
          </button>
          <button
            type="button"
            className="btnNext w-100"
            onClick={btn2Functionality}
            disabled={submitLoading}
          >
            {btn2Text}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfiration;
